// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2bdf7801","977":"663c7e72"}[chunkId] + ".chunk.js";
};